/**
 * DocumentState is the lifecycle state of a document. It is global and
 * subdomain independent. A local state of a document, e.g. the state of a
 * work order, is a separate field named <entity>State.
 */
export enum DocumentState {
  /** A draft is editable and may be incomplete. */
  Draft = "draft",
  /** A ready document is complete and may be handed to the customer. */
  Ready = "ready",
  /** An immutable document is written down and cannot be changed. */
  Immutable = "immutable",
}

export const DocumentStateList: DocumentState[] = Object.values(DocumentState);

/**
 * DocumentStateBase holds the lifecycle state of a document. Every document
 * of the HTZ, RLT and VBS subdomains carries it.
 */
export interface DocumentStateBase {
  state: DocumentState;
  /** The id of the user who set the current state. */
  stateSetBy?: string;
  /** The time the current state was set. */
  stateSetAt?: string;
}
